import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useCity } from "@/contexts/CityContext";
import { RoundsList } from "@/components/rounds/RoundsList";
import { track } from "@/lib/analytics";
import { useRoundsCommunities } from "@/lib/rounds";

export default function RoundsCommunity() {
  const { city } = useCity();
  const { slug = "" } = useParams<{ slug: string }>();
  const communities = useRoundsCommunities(city.slug);

  useEffect(() => track("rounds_view"), []);

  if (communities.isLoading) return <div className="pb-rounds-state" role="status">Loading community…</div>;
  if (communities.isError || !communities.data) {
    return (
      <div className="pb-rounds-state pb-rounds-state--error" role="alert">
        <span>The community could not be loaded.</span>
        <button type="button" onClick={() => void communities.refetch()}>Retry</button>
      </div>
    );
  }

  const community = communities.data.communities.find((item) => item.slug === slug);
  if (!community) {
    return (
      <div className="pb-rounds-state">
        <span>That Rounds community does not exist.</span>
        <Link to="/board/rounds">Back to all Rounds</Link>
      </div>
    );
  }

  return (
    <RoundsList
      citySlug={city.slug}
      communities={communities.data.communities}
      community={community}
      title={community.name}
      description={community.description}
    />
  );
}
